import { useEffect } from 'react';
import { useCommerce } from '../account/commerce';
import type { Ride } from '../domain/ride';
import type { StudioDraft } from './studio-draft';

/** The query selects sample content only after local capabilities authorize Studio. */
export function useLocalStudioSample(disabled: boolean, onOpen: (ride: Ride, draft: StudioDraft) => void) {
  const status = useCommerce()?.status;
  useEffect(() => {
    if (disabled || status !== 'local' || new URLSearchParams(location.search).get('sample') !== 'landscape') return;
    let active = true;
    void import('./local-studio-sample').then(({ localLandscapeSample }) => {
      if (!active) return;
      const { ride, draft } = localLandscapeSample();
      onOpen(ride, draft);
    });
    return () => { active = false; };
  }, [disabled, onOpen, status]);
}
